import {hasText} from "utils/helpers";
import {ServerError} from "../play-model";
import {useMessages} from "../language/language";
import { PropsWithChildren } from "react";

export type AlertType = "primary"|"secondary"|"success"|
  "danger"|"warning"|"info"|"light"|"dark"

export type AlertFloating = "bottom"|"top"

export default function Alert(props: PropsWithChildren<{
  type: AlertType, 
  floating?: AlertFloating}>
) {
  const {type, children, floating} = props;
  
  let className = `alert alert-${type}`
  if (!!floating) {
    className += `floating ${floating}`
  }
  
  return <div className={className}>
    {children}
  </div>
}

export function ErrorAlert(props: {
  hasError?: boolean,
  error?: string|null|undefined,
  serverError?: ServerError
  floating?: AlertFloating
}) {
  const msg = useMessages();
  const { hasError, floating } = props;
  let error = props.error;
  if (!hasText(error) && props.serverError !== null && typeof props.serverError !== 'undefined') {
    error = msg.serverErrorToString(props.serverError)    
  }
  
  let showError = hasText(error) && hasError;
  
  if (showError) {
    return <Alert type="danger" floating={floating}>{error}</Alert>
  } else {
    return null;
  }
}